export interface AuthorProviderInfo {
	id: string;
	provider: string;
}

export function parseAuthorId(authorId: string): AuthorProviderInfo | undefined {
	const [provider, id] = authorId?.split("|") ?? [];
	if (!provider || !id) {
		return;
	}

	return { id, provider };
}
